/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

/** Copies through a hidden textarea. Returns whether the browser reports the copy worked. */
export function copyToClipboard(value: string): boolean {
  const textarea = document.createElement('textarea');
  textarea.style.position = 'fixed';
  textarea.style.left = '0';
  textarea.style.top = '0';
  textarea.style.opacity = '0';
  textarea.value = value;
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  let copied = false;
  try {
    /* eslint-disable */
    copied = document.execCommand('copy'); // copy passed value
    /* eslint-enable */
  } finally {
    document.body.removeChild(textarea);
  }
  return copied;
}
